import { render, staticRenderFns } from "./SBoxStemdoerEducation.vue?vue&type=template&id=648c6580&scoped=true"
import script from "./sBoxStemdoerEducation.ts?vue&type=script&lang=ts&external"
export * from "./sBoxStemdoerEducation.ts?vue&type=script&lang=ts&external"
import style0 from "./SBoxStemdoerEducation.vue?vue&type=style&index=0&id=648c6580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c6580",
  null
  
)

export default component.exports